export const colors = {
  primary: {
    color: 'primary',
    bg: 'bg-primary',
    text: 'text-primary',
    bg_disable: 'bg-primary-100',
    border: 'border-primary',
    border_disable: 'border-primary-100'
  },
  green: {
    color: 'green',
    bg: 'bg-green',
    text: 'text-green',
    bg_disable: 'bg-green-100',
    border: 'border-green',
    border_disable: 'border-green-100'
  },
  purple: {
    color: 'purple',
    bg: 'bg-purple',
    text: 'text-purple',
    bg_disable: 'bg-purple-150',
    border: 'border-purple',
    border_disable: 'border-purple-150'
  },
  orange: {
    color: 'orange',
    bg: 'bg-orange',
    text: 'text-orange',
    bg_disable: 'bg-orange-150',
    border: 'border-orange',
    border_disable: 'border-orange-150'
  },
  pink: {
    color: 'pink',
    bg: 'bg-pink',
    text: 'text-pink',
    bg_disable: 'bg-pink-150',
    border: 'border-pink',
    border_disable: 'border-pink-150'
  },
  teal: {
    color: 'teal',
    bg: 'bg-teal',
    text: 'text-teal',
    bg_disable: 'bg-teal-200',
    border: 'border-teal',
    border_disable: 'border-teal-200'
  }
}
